<template>
  <div class="about">
    <div id="myMap" ref="chart"></div>
    <DetailsCards
      :storeList="storeList"
      :storeInfo="storeInfo"
      @close="showCard = false"
      v-if="showCard"
      class="infoCards"
    />
    <el-button
      type="primary"
      size="mini"
      title="点击返回上一级"
      class="btn"
      @click="upside"
      >{{ adName }}</el-button
    >

    <!-- 添加企业列表图标 -->
    <template v-if="currentDataList.length">
      <div
        v-if="!showCompanyList"
        class="company-list-icon"
        @click="toggleCompanyList"
      >
        <span>{{ this.level >= 1 ? '仓库列表' : '公司列表' }}</span>
      </div>

      <!-- 添加企业列表容器 -->
      <div v-else class="company-list-container" v-show="showCompanyList">
        <div class="company-list-header">
          <span>{{ this.level >= 1 ? '仓库列表' : '公司列表' }}</span>
          <img
            src="~@/assets/recycling/echartsMap/close.svg"
            @click="toggleCompanyList"
            alt="关闭"
          />
        </div>
        <div class="company-list-content">
          <div
            v-for="(company, index) in currentDataList"
            :key="index"
            class="company-item"
            :class="choseComponyName === company.name ? 'choseColor' : ''"
            :title="company.name"
            @click="showCompanyDetail(company)"
          >
            {{ company.name }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { isPointInMultiPolygon } from '@/util/echartTool.js';
import Store from '@/store';
import allAdcode from '@/components/echartsMenu/json/allAdcode.json';
import centroidList from '@/util/centroidList.json';
import allCentrids from '@/util/allCentrids.json';
import cityScale from '@/components/echartsMenu/json/cityScale.json';
import { dom1, dom2 } from '@/components/echartsMenu/dom';
import {
  getAmountOfDismantling,
  getStatiosTypedata,
  getPointList,
} from '@/API/echarts/echarts';
import {
  getCompanyDetail,
  getCompanyList,
  getMapDataLevel2,
  getMapDataLevel3,
  getStoreDetail,
} from '@/API/chinaMapApi/chinaMapApi';
import { AlarmClock } from '@element-plus/icons-vue';
import * as echarts from 'echarts';
let myChartMap = null; //地图
let charTimer = null; // 点位轮播
const that = this; // 保存 this 引用
// 营造地图辐射效果的经纬度
const provinceCenters = [
  { name: '北京市', coords: [116.4074, 39.9042], adcode: '110000' },
  { name: '天津市', coords: [117.2008, 39.0842], adcode: '120000' },
  { name: '上海市', coords: [121.4737, 31.2304], adcode: '310000' },
  { name: '重庆市', coords: [106.5516, 29.563], adcode: '500000' },
  { name: '河北省', coords: [114.5149, 38.0428], adcode: '130000' },
  { name: '山西省', coords: [112.5628, 37.8706], adcode: '140000' },
  { name: '辽宁省', coords: [123.4315, 41.8057], adcode: '210000' },
  { name: '吉林省', coords: [125.3245, 43.8171], adcode: '220000' },
  { name: '黑龙江省', coords: [126.6349, 45.7569], adcode: '230000' },
  { name: '江苏省', coords: [118.7969, 32.0603], adcode: '320000' },
  { name: '浙江省', coords: [120.1551, 30.2797], adcode: '330000' },
  { name: '安徽省', coords: [117.2272, 31.8206], adcode: '340000' },
  { name: '福建省', coords: [119.3062, 26.0745], adcode: '350000' },
  { name: '江西省', coords: [115.8921, 28.6765], adcode: '360000' },
  { name: '山东省', coords: [117.0009, 36.6758], adcode: '370000' },
  { name: '河南省', coords: [113.6253, 34.7466], adcode: '410000' },
  { name: '湖北省', coords: [114.3055, 30.5928], adcode: '420000' },
  { name: '湖南省', coords: [112.9388, 28.2282], adcode: '430000' },
  { name: '广东省', coords: [113.2644, 23.1291], adcode: '440000' },
  { name: '海南省', coords: [110.3312, 20.0444], adcode: '460000' },
  { name: '四川省', coords: [104.0668, 30.6719], adcode: '510000' },
  { name: '贵州省', coords: [106.7135, 26.5783], adcode: '520000' },
  { name: '云南省', coords: [102.7122, 25.0406], adcode: '530000' },
  { name: '陕西省', coords: [108.948, 34.2631], adcode: '610000' },
  { name: '甘肃省', coords: [103.8343, 36.0611], adcode: '620000' },
  { name: '青海省', coords: [101.7782, 36.6231], adcode: '630000' },
  { name: '内蒙古自治区', coords: [111.6708, 40.8414], adcode: '150000' },
  { name: '广西壮族自治区', coords: [108.3275, 22.824], adcode: '450000' },
  { name: '西藏自治区', coords: [91.1409, 29.6455], adcode: '540000' },
  { name: '宁夏回族自治区', coords: [106.2782, 38.4872], adcode: '640000' },
  { name: '新疆维吾尔自治区', coords: [87.6177, 43.7928], adcode: '650000' },
  { name: '香港特别行政区', coords: [114.0579, 22.3964], adcode: '810000' },
  { name: '澳门特别行政区', coords: [113.5491, 22.1987], adcode: '820000' },
  { name: '台湾省', coords: [121.509, 25.0443], adcode: '710000' },
];
export default {
  name: 'about',
  components: {
    AlarmClock,
    DetailsCards: () =>
      import('@/views/ChinaMapData/components/common/detailsCard.vue'),
  },
  data() {
    return {
      storeList: [],
      storeInfo: {},
      mapPointArr: '',
      timer: '',
      showCard: false,
      optionMap: {
        //地理坐标系组件
        tooltip: {
          show: true, //是否显示提示框组件，包括提示框浮层和 axisPointer。
          trigger: 'item', //触发类型。item,axis,none
          enterable: true, //鼠标是否可进入提示框浮层中，默认为false，
          showContent: true, //是否显示提示框浮层
          triggerOn: 'click', //提示框触发的条件(mousemove|click|none)
          showDelay: 0, //浮层显示的延迟，单位为 ms，默认没有延迟，也不建议设置。在 triggerOn 为 'mousemove' 时有效。
          textStyle: {
            color: 'white',
            fontSize: 12,
          },
          padding: 0,
          position: function (pt) {
            let X = pt[0];
            let Y = pt[1];
            return [X + 10, Y + 10];
          },

          hideDelay: 10,
          backgroundColor: 'rgba(0,0,0,0)', //提示框浮层的背景颜色。
          borderColor: 'rgba(0,0,0,0)', //图形的描边颜色
          borderWidth: 1,
          alwaysShowContent: true,
          transitionDuration: 1,
        },
        geo: [
          {
            map: 'sichuan',
            aspectScale: 1, //用于 scale 地图的长宽比
            zoom: 0.84,
            layoutCenter: ['50%', '50%'], //定义地图中心在屏幕中的位置
            layoutSize: '90%', //地图的大小
            show: true, //是否显示地理坐标系组件。
            roam: false, //是否开启鼠标缩放和平移漫游。默认不开启。如果只想要开启缩放或者平移，可以设置成 'scale' 或者 'move'。设置成 true 为都开启
            label: {
              //图形上的文本标签
              show: true,
              color: '#fff',
              align: 'center',
              borderRadius: 2,
              borderWidth: 1,
              formatter: function (params) {
                const name = params.name;
                // 对特定地区应用不同样式
                if (window.companyAdcodeList) {
                  const result =
                    window.companyAdcodeList?.some((item) => {
                      return item.name === name;
                    }) || false;
                  if (result) {
                    return `{b|${name}}`; // 长名称使用不同样式
                  } else {
                    return '';
                  }
                } else {
                  return `{b|${name}}`;
                }
              },
              rich: {
                b: {
                  color: '#fff',
                  fontSize: 14,
                  height: 18,
                  lineHeight: 18,
                  align: 'center',
                },
              },
            },
            tooltip: {
              show: true, //是否显示提示框组件，包括提示框浮层和 axisPointer。
              trigger: 'item', //触发类型。item,axis,none
              enterable: true, //鼠标是否可进入提示框浮层中，默认为false，
              showContent: true, //是否显示提示框浮层
              triggerOn: 'click', //提示框触发的条件(mousemove|click|none)
              showDelay: 0, //浮层显示的延迟，单位为 ms，默认没有延迟，也不建议设置。在 triggerOn 为 'mousemove' 时有效。
              textStyle: {
                color: 'white',
                fontSize: 12,
              },
              padding: 0,
              position: function (pt, params, dom, rect, size) {
                if (params.componentSubType == 'effectScatter') {
                  return ['10%', '-11%'];
                } else {
                  let X = pt[0];
                  // 提示框的宽度和高度
                  const tooltipHeight = size.contentSize[1];
                  const tooltipWidth = size.contentSize[0];
                  // 可视区域的宽度和高度
                  const viewHeight = size.viewSize[1];
                  const viewWidth = size.viewSize[0];
                  if (X + tooltipWidth > viewWidth) {
                    X = pt[0] - tooltipWidth - 10; // 向上弹出，并留10px间距
                  } else {
                    X += 10; // 正常情况向下偏移10px
                  }
                  // 计算y坐标 - 如果下方空间不足则向上弹出
                  let Y = pt[1];
                  if (Y + tooltipHeight > viewHeight) {
                    Y = pt[1] - tooltipHeight - 10; // 向上弹出，并留10px间距
                  } else {
                    Y += 10; // 正常情况向下偏移10px
                  }
                  return [X + 10, Y + 10];
                }
              },
              formatter: function (params) {
                return;
                // 如果是 marker 聚合图标，则阻止默认行为
                if (params.componentType === 'series') {
                  return false; // 阻止默认点击行为
                }
                return `<div style="width: 200px;height: 300px" id="cardBox"/>`;
              },
              hideDelay: 10,
              backgroundColor: 'rgba(0,0,0,0)', //提示框浮层的背景颜色。
              borderColor: 'rgba(0,0,0,0)', //图形的描边颜色
              borderWidth: 1,
              alwaysShowContent: true,
              transitionDuration: 1,
            },
            itemStyle: {
              //地图区域的颜色
              areaColor: {
                type: 'linear',
                x: 5,
                y: 210,
                x2: 65,
                y2: 10,
                colorStops: [
                  {
                    offset: 0.69,
                    color: 'rgba(44, 142, 104, 1)',
                  },
                  {
                    offset: 1,
                    color: 'rgba(38, 110, 81, 1)',
                  },
                ],
                global: true, // 缺省为 false
              },
              borderColor: 'rgba(85, 237, 146, 1)',
              borderWidth: 1,
            },
            //高亮状态下的多边形和标签样式
            emphasis: {
              itemStyle: {
                show: false,
                color: '#fff',
                shadowBlur: 10, // 阴影模糊大小
                shadowColor: 'rgba(0, 0, 0, 0.7)', // 阴影颜色
                shadowOffsetX: 0, // 阴影X偏移
                shadowOffsetY: 10, // 阴影Y偏移（产生上浮效果）
                borderWidth: 2, // 边框加粗
                areaColor: {
                  type: 'linear',
                  x: 100,
                  y: 100,
                  x2: 400,
                  y2: 400,
                  colorStops: [
                    { offset: 0, color: 'rgba(44, 142, 104, 1)' },
                    { offset: 1, color: 'rgba(38, 110, 81, 1)' },
                  ],
                  global: true, // 缺省为 false
                },
              },
              label: {
                show: true,
                color: '#fff',
              },
            },
          },
          //重影
          {
            type: 'map',
            map: 'sichuan',
            zlevel: -1,
            aspectScale: 1,
            zoom: 0.84,
            layoutCenter: ['50%', '51%'],
            layoutSize: '120%',
            roam: false,
            silent: true,
            itemStyle: {
              borderWidth: 1,
              borderColor: 'rgba(58,149,253,0.8)',
              shadowOffsetY: 5,
              shadowBlur: 15,
              areaColor: 'rgba(85, 237, 146, 1)',
            },
          },
          {
            type: 'map',
            map: 'sichuan',
            zlevel: -2,
            aspectScale: 1,
            zoom: 0.84,
            layoutCenter: ['50%', '52%'],
            layoutSize: '120%',
            roam: false,
            silent: true,
            itemStyle: {
              borderWidth: 1,
              borderColor: 'rgba(30, 130, 95,0.6)',
              shadowOffsetY: 5,
              shadowBlur: 15,
              areaColor: 'rgba(30, 130, 95, 1)',
            },
          },
          {
            type: 'map',
            map: 'sichuan',
            zlevel: -3,
            aspectScale: 1,
            zoom: 0.84,
            layoutCenter: ['50%', '53%'],
            layoutSize: '80%',
            roam: false,
            silent: true,
            itemStyle: {
              borderWidth: 1,
              borderColor: 'rgba(22, 102, 74,0.4)',
              shadowOffsetY: 15,
              shadowBlur: 10,
              areaColor: 'rgba(22, 102, 74, 1)',
            },
          },
          {
            type: 'map',
            map: 'sichuan',
            zlevel: -4,
            aspectScale: 1,
            zoom: 0.84,
            layoutCenter: ['50%', '54%'],
            layoutSize: '100%',
            roam: false,
            silent: true,
            itemStyle: {
              borderWidth: 5,
              borderColor: 'rgba(18, 82, 59,0.8)',
              shadowOffsetY: 15,
              shadowBlur: 10,
              areaColor: 'rgba(18, 82, 59, 1)',
            },
          },
        ],
        //定义图标的具体数据和类型
        series: [
          {
            type: 'effectScatter', //带有涟漪特效的动画散点
            zlevel: 3,
            coordinateSystem: 'geo', //使用的坐标系
            emphasis: {
              //高亮的图形样式和标签样式
              label: {
                show: true,
                position: 'top',
                color: '#fff',
                formatter: '{b|{b}}',
                rich: {}, //自定义富文本样式。利用富文本样式，可以在标签中做出非常丰富的效果
              },
            },
            label: {
              show: true,
              position: 'top',
              color: '#fff',
              rich: {}, //自定义富文本样式。利用富文本样式，可以在标签中做出非常丰富的效果
            },
            data: [],
            symbol: 'circle',
            symbolSize: [8, 3], //特效图形标记大小orange
            itemStyle: {
              color: 'orange',
              shadowBlur: 3,
              shadowColor: 'orange',
            },
            effectType: 'ripple', //特效类型，只有 ripple（涟漪）
            showEffectOn: 'render', //配置何时显示特效。可选参数 render（绘制完成后）、emphasis（高亮时）
            rippleEffect: {
              scale: 5, //波纹最大缩放比例
              brushType: 'stroke', //波纹绘制方式，可选 stroke、fill
            },
          },
          {
            type: 'lines',
            coordinateSystem: 'geo',
            polyline: false,
            lineStyle: {
              color: '#4cd964',
              width: 1,
              opacity: 0.5,
              curveness: 0.1,
              type: 'dashed',
              dashArray: [5, 5],
            },
            data: [],
          },
          // 动态流动虚线（带间隔箭头）
          {
            type: 'lines',
            coordinateSystem: 'geo',
            polyline: false,
            lineStyle: {
              color: 'rgb(194,85,85)',
              width: 1,
              opacity: 0.9,
              curveness: 0.1,
              type: 'dashed',
              dashArray: [4, 4],
              lineCap: 'round',
            },
            effect: {
              show: true,
              period: 4, // 箭头流动周期（秒），数值越大流动越慢，需和间隔匹配
              trailLength: 0.1,
              color: '#ffffff',
              symbol: 'arrow',
              symbolSize: 5,
            },
            // 关键：启用动画延迟（必须开启animation才能生效）
            animation: true,
            animationDuration: 0, // 路径本身无动画，仅箭头有延迟
            data: [], // 复用带animationDelay的路径数据
          },
        ],
      },
      // 从阿里dataV数据库直接获取指定区域的geojson地图数据
      publicUrl:
        process.env.VUE_APP_BASE_URL + '/third/api/geo/datav/areas_v3/bound/',
      level: 0,
      historyData: [],
      adName: '中国',
      alladcode: '',
      resData: [],
      siChuanAreaData: '',
      currentHighlightIndex: -1, // 当前高亮点位索引
      isHoveringPoint: false, // 是否悬停在点位上
      showCompanyList: false, // 控制企业列表显示
      currentData: [], // 存储当前点位数据
      currentDataList: [], // 存储当前企业合集数据
      choseComponyName: '',
      removeFunction: null,
    };
  },
  mounted() {
    this.getCompanys();
    myChartMap = this.$echarts.init(document.getElementById('myMap'));
    myChartMap.showLoading({
      text: '加载中...',
      textColor: '#fff',
      color: '#fff',
      maskColor: 'rgba(0 ,0 ,0 ,0.3 )',
      zlevel: 0,
    });
    // 初始化echarts地图
    this.initChart();
    // 全局移除函数，用于在echarts图层移除dom节点
    this.removeFunction = (e) => {
      // 1. 找到视频元素并停止播放
      const videoElement = e.parentNode.parentNode.parentNode
        .closest('div')
        .querySelector('video');
      if (videoElement) {
        videoElement.pause();
        videoElement.currentTime = 0;
      }
      e.parentNode.parentNode.parentNode.style.display = 'none';
      this.choseComponyName = '';
    };
    window.remove = this.removeFunction;
  },
  watch: {
    '$store.state.chinaMap.dataType': {
      handler: function (val) {
        this.optionMap.series[0].data = null;
        this.level = 0;
        this.resData = [];
        this.currentData = [];
        this.historyData.length = 1;
        this.$store.state.chinaMap.cityName = '中国';
        this.$store.commit('chinaMap/changeCurrentlyMapAdcode', undefined);
        this.getCompanys();
      },
    },
    '$store.state.chinaMap.glanceType': {
      handler: function (val) {
        if (this.level === 1) {
          this.getMapLevel2Icon();
        } else if (this.level === 2) {
          this.getMapLevel3Icon();
        }
      },
    },
    '$store.state.chinaMap.companyId': {
      handler: function () {
        if (this.level === 1) {
          this.getMapLevel2Icon();
        } else if (this.level === 2) {
          this.getMapLevel3Icon();
        }
      },
    },
    level: {
      handler: function (val) {
        this.showCard = false;
        if (val === 0) {
          this.$store.commit('chinaMap/changeGlanceType', undefined);
          this.$store.commit('chinaMap/changeTimeRange', undefined);
        }
        this.$store.commit('chinaMap/changeMapLevel', val);
      },
    },
  },
  methods: {
    /**
     * 根据adcode筛选数据
     * @param {string} adcode - 要筛选的adcode
     * @param {Array} allCentrids - 附件1的数据
     * @param {Array} data - 附件2的数据
     * @returns {Array} 匹配到的数据数组
     */
    filter(adcode, allCentrids, data) {
      if (!allCentrids.length || !Array.isArray(allCentrids)) {
        console.error('allCentrids 参数无效:', allCentrids);
        return [];
      }
      let result = [];
      allCentrids.forEach((item) => {
        if (!item) return;
        if (item.adcode == adcode) {
          if (item.districts && Array.isArray(item.districts)) {
            item.districts.forEach((district) => {
              data.forEach((temp) => {
                if (district.adcode == temp.adcode) {
                  result.push(temp);
                }
              });
            });
          }
        } else {
          if (item.districts && Array.isArray(item.districts)) {
            const nestedResults = this.filter(adcode, item.districts, data);
            result = result.concat(nestedResults);
          }
        }
      });
      return result;
    },
    // 切换企业列表显示状态
    toggleCompanyList() {
      this.showCompanyList = !this.showCompanyList;
      if (!this.showCompanyList) {
        this.showCard = false;
      }
    },
    // 显示企业详情
    showCompanyDetail(company) {
      let apiMethods;
      if (this.level > 1) {
        apiMethods = getStoreDetail;
      } else {
        apiMethods = getCompanyDetail;
      }
      apiMethods(company.id)
        .then((res) => {
          if (res.code === 200) {
            this.storeList =
              this.level > 1
                ? res.data?.categories
                : [
                    {
                      name: '仓库',
                      amount: res.data.warehouseCount || '',
                      unit: '个',
                    },
                    {
                      name: '客户',
                      amount: res.data.customerCount || '',
                      unit: '个',
                    },
                  ];
            this.storeInfo = {
              name: res.data?.name || '',
              address: res.data?.address || '',
            };
          }
        })
        .finally(() => {
          this.showCard = true;
        });
    },
    getComponyInfo(params) {
      const componyName = document.getElementById('componyName');
      const legalPerson = document.getElementById('legalPerson');
      const contact = document.getElementById('contact');
      const address = document.getElementById('address');
      componyName.innerText = params.data.name;
      legalPerson.innerText = params.data.linkman;
      contact.innerText = params.data.cellPhone;
      address.innerText = params.data.address;
    },
    getPointLists() {
      //此处获取后端接口返回数据
      // 轮播展示的城市数据
      let type = this.$store.state.chinaMap.dataType == 1 ? 1031 : 1030; //1030省社,1031全省
      getPointList({ type }).then((res) => {
        if (res.code === 200) {
          this.mapPointArr = res.data;
          console.log(this.mapPointArr, '全量点位获取');
        } else {
          this.mapPointArr = [];
        }
      });
    },
    getCityStations(params) {
      let adCode = this.alladcode.filter(
        (areaJson) => areaJson.name === params.name,
      )[0].adcode;
      let type = this.$store.state.chinaMap.dataType == 1 ? 1031 : 1030; //1030省社,1031全省
      let data = {
        type: type,
        timestr: this.$store.state.chinaMap.timeRange[0],
        quarter: this.$store.state.chinaMap.timeRange[1],
      };
      const recycleStation = document.getElementById('recycleStation');
      const transferStation = document.getElementById('transferStation');
      const sortingCenter = document.getElementById('sortingCenter');
      const dismantlingCenter = document.getElementById('dismantlingCenter');
      const industrialPark = document.getElementById('industrialPark');
      const wasteEnterprise = document.getElementById('wasteEnterprise');
      const cityName = document.getElementById('cityName');
      getAmountOfDismantling(adCode, data).then((res) => {
        if (res.code == 200) {
          recycleStation.innerText = res.data?.recycleStation
            ? res.data?.recycleStation
            : 0;
          transferStation.innerText = res.data?.transferStation
            ? res.data?.transferStation
            : 0;
          sortingCenter.innerText = res.data?.sortingCenter
            ? res.data?.sortingCenter
            : 0;
          dismantlingCenter.innerText = res.data?.dismantlingCenter
            ? res.data?.dismantlingCenter
            : 0;
          industrialPark.innerText = res.data?.industrialPark
            ? res.data?.industrialPark
            : 0;
          wasteEnterprise.innerText = res.data?.wasteEnterprise
            ? res.data?.wasteEnterprise
            : 0;
          cityName.innerText = params.name;
        }
      });
    },
    // 南沙诸岛以缩略图展示
    async formatJson(chinaGeoJson) {
      chinaGeoJson.features.forEach((v) => {
        if (v.properties && v.properties.name == '海南省') {
          v.geometry.coordinates = v.geometry.coordinates.slice(0, 1);
        }
      });
      // 过滤掉海南诸岛边界线
      chinaGeoJson.features = chinaGeoJson.features.filter(
        (item) => item.properties.adcode !== '100000_JD',
      );
      return chinaGeoJson;
    },
    // 初始化
    async initChart() {
      // 获取地图name对应的adcode行政区划编码
      let geoJson = allAdcode;
      this.alladcode = geoJson;
      window.alladcode = geoJson;
      // 获取datav在线的四川省地图
      let areaJsonName = '100000_full.json';
      let chinaGeoJson = require(
        `@/components/echartsMenu/json/areaGeojson/${areaJsonName}`,
      );
      let formatChinaGeoJson = await this.formatJson(chinaGeoJson);
      // 鼠标移入点位的弹窗
      let rich = {
        b: {
          color: '#fff',
          backgroundColor: {
            image: require('../../../../../../public/home/chinaPoint.svg'),
          },
          padding: [20, 30],
          fontSize: 14,
          align: 'center',
        },
      };
      this.optionMap.series[0].emphasis.label.rich = rich;
      this.optionMap.series[0].label.rich = rich;
      this.initEcharts(formatChinaGeoJson, '中国');
    },
    //echarts绘图
    initEcharts(geoJson, name) {
      this.formatChart(geoJson, name);
      myChartMap.hideLoading();
      window.addEventListener('resize', () => {
        myChartMap.resize();
      });
      this.historyData.push({ geoJson, name });
      myChartMap.off('dblclick');
      myChartMap.on('dblclick', async (params) => {
        if (this.$store.state.chinaMap.dataType === 3) {
          return;
        }
        // 获取当前点击区域的adcode
        let clickRegionCode = this.alladcode.filter(
          (areaJson) => areaJson.name === params.name,
        )[0].adcode;
        const provinceAdcode = [
          110000, 120000, 130000, 140000, 150000, 210000, 220000, 230000,
          310000, 320000, 330000, 340000, 350000, 360000, 370000, 410000,
          420000, 430000, 440000, 450000, 460000, 500000, 520000, 530000,
          540000, 610000, 620000, 630000, 640000, 650000, 710000, 810000,
          820000,
        ];
        let provinceFindResult = provinceAdcode.includes(
          Number(clickRegionCode),
        );
        // 如果是市级城市，且不是四川省，则阻止默认行为
        if (provinceFindResult) {
          return false;
        }
        // 如果是 marker 聚合图标，则阻止默认行为
        if (params.componentType === 'series') {
          return false; // 阻止默认点击行为
        }
        if (this.level >= 2) return;
        this.level++;
        this.$store.state.chinaMap.cityName = params.name;
        // 记录当前下转图层的adcode
        this.$store.commit(
          'chinaMap/changeCurrentlyMapAdcode',
          clickRegionCode,
        );
        // 获取地图二级撒点数据
        if (this.level === 1) {
          this.getMapLevel2Icon();
          this.currentDataList = [];
          // 获取地图三级撒点数据
        } else if (this.level === 2) {
          await this.getMapLevel3Icon();
        }
        this.$store.commit('chinaMap/changeGlanceType', undefined);
        // 点击的是当前地图
        if (params.componentType !== 'geo') return;
        // 没有区县的地级市,东莞,中山,儋州,三沙,嘉峪关
        let adcodeArr = ['460400', '460300', '441900', '442000', '620200'];
        let areaName;
        let regionGeoJson = [];
        // 区县或者没有区县的地级市
        if (
          clickRegionCode.toString().slice(-2) != '00' ||
          adcodeArr.includes(clickRegionCode.toString())
        ) {
          // 通过缓存的城市名称层级数据关系，确定当点击到第三层图层后，父级的城市名（用于规避类似于’市中区‘有多个城区名字相同的情况）
          let parentName = this.historyData[this.historyData.length - 1].name;
          let parentAreaInfo = allAdcode.filter((item) => {
            if (item.name == parentName) {
              return item;
            }
          });
          // 获取父级adcode对应的geojson离线文件
          areaName = `${parentAreaInfo[0].adcode}_full.json`;
          let areaGeojson = require(
            `@/components/echartsMenu/json/areaGeojson/${areaName}`,
          );
          // 循环父级geojson离线文件，获取包含当前点击区域的geojson离线数据
          let features = areaGeojson.features;
          for (let i = 0; i < features.length; i++) {
            // 如果父级文件中的城市名与当前点击城市名一致，则获取geojson渲染第三层数据
            if (features[i].properties.name == params.name) {
              regionGeoJson = features[i];
              regionGeoJson = {
                type: 'FeatureCollection',
                features: [regionGeoJson],
              };
            }
          }
        } else {
          areaName = `${clickRegionCode}_full.json`;
          regionGeoJson = require(
            `@/components/echartsMenu/json/areaGeojson/${areaName}`,
          );
        }
        this.initEcharts(regionGeoJson, params.name);
      });
      myChartMap.off('click');
      myChartMap.on('click', (params) => {
        return;
        // 如果是 marker 聚合图标，则阻止默认行为
        if (params.componentType === 'series') {
          return false; // 阻止默认点击行为
        }
        this.choseComponyName = params.name;
        const cardBox = document.getElementById('cardBox');
        if (this.level == 2 && params.componentSubType == 'effectScatter') {
          this.showCompanyDetail(params.data);
        } else if (this.level == 0 || this.level == 1) {
          cardBox.innerHTML = dom1;
        } else {
          cardBox.innerHTML = ``;
          cardBox.style.display = 'none';
        }

        // if (params.componentSubType !== 'effectScatter') {
        //   this.getCityStations(params);
        // } else {
        //   this.getComponyInfo(params);
        // }
      });

      // 添加鼠标移入移出事件
      myChartMap.off('mouseover');
      myChartMap.off('mouseout');
      myChartMap.on('mouseover', (params) => {
        if (params.componentSubType === 'effectScatter') {
          this.isHoveringPoint = true;
          // 停止轮播
          if (charTimer) {
            clearInterval(charTimer);
            charTimer = null;
          }
          // 高亮当前点位
          this.currentHighlightIndex = this.optionMap.series[0].data.findIndex(
            (item) => item.name === params.name,
          );
          this.highLightPoint(
            this.optionMap.series[0].data,
            this.currentHighlightIndex,
          );
          myChartMap.setOption(this.optionMap);
        }
      });
      myChartMap.on('mouseout', (params) => {
        if (params.componentSubType === 'effectScatter') {
          this.isHoveringPoint = false;
          this.currentHighlightIndex = -1;
          // 恢复轮播
          this.startPointCarousel();
        }
      });
    },
    // 点位颜色高亮
    highLightPoint(currentData, index) {
      currentData.forEach((v, key) => {
        let flag = key == index ? 'aqua' : 'orange';
        v.itemStyle = {
          color: flag,
          shadowColor: flag,
        };
      });
      this.optionMap.series[0].label.formatter = (e) => {
        return e.name === currentData[index].name ? `{b|${e.name}}` : '';
      };
    },
    // 启动点位轮播
    startPointCarousel() {
      if (charTimer) {
        clearInterval(charTimer);
        charTimer = null;
      }

      this.currentData = this.optionMap.series[0].data;
      // 点位大于2个才循环轮播
      if (this.currentData.length > 1) {
        let i =
          this.currentHighlightIndex >= 0 ? this.currentHighlightIndex : 0;
        charTimer = setInterval(() => {
          if (this.isHoveringPoint) return; // 如果鼠标在点位上，不执行轮播

          i++;
          if (i >= this.currentData.length) i = 0;
          this.highLightPoint(this.currentData, i);
          myChartMap.setOption(this.optionMap);
        }, 1000 * 3);
      }
    },
    // 格式图表
    formatChart(geoJson, name) {
      this.$store.state.chinaMap.isLower = false;
      // 过滤出当前地图的点位
      this.currentData = this.resData?.filter((v) => {
        return isPointInMultiPolygon([v.lon, v.lat], geoJson.features);
      });
      console.log(this.resData, geoJson, name, 'name666');
      // 当前展示地图所属区域
      this.adName = name || '中国';
      console.log(geoJson, 'geoJson');
      this.$echarts.registerMap(name, geoJson);
      this.optionMap.geo.forEach((v) => {
        v.map = name;
        v.layoutSize = cityScale[name] || '100%';
      });
      this.currentData.forEach((item) => {
        item.value = [item.lon, item.lat];
      });
      this.currentDataList = this.currentData;
      this.optionMap.series[0].data = this.currentData;
      // 点位颜色高亮
      this.highLightPoint(this.currentData, 0);
      this.optionMap.series[0].label.show = true;
      myChartMap.clear();
      myChartMap.setOption(this.optionMap);

      // 启动轮播
      this.startPointCarousel();
    },
    // 返回上一级
    upside() {
      if (this.historyData.length > 1) {
        this.$store.commit('chinaMap/changeGlanceType', undefined);
        this.historyData.pop();
        let upData = this.historyData[this.level - 1];
        this.resData = [];
        this.currentDataList = [];
        this.$store.state.chinaMap.cityName = this.historyData.name
          ? this.historyData.name
          : '中国';
        this.formatChart(upData.geoJson, upData.name);
        this.level--;
      }
      this.$store.state.chinaMap.cityName =
        this.historyData[this.historyData.length - 1].name;
      if (this.$store.state.chinaMap.cityName === '中国') {
        this.$store.state.chinaMap.currentlyMapAdcode = '';
      } else {
        this.$store.state.chinaMap.currentlyMapAdcode = this.alladcode.filter(
          (areaJson) => areaJson.name === this.$store.state.chinaMap.cityName,
        )[0].adcode;
      }
      if (this.level === 0) {
        this.getCompanys();
      } else if (this.level === 1) {
        this.currentDataList = [];
        this.getMapLevel2Icon();
      }
    },
    /**
     * 递归处理地理坐标数据
     * @param {Array} coords - 坐标数据
     * @param {Function} callback - 对每个坐标点的处理函数
     */
    processCoordinates(coords, callback) {
      if (Array.isArray(coords[0]) && typeof coords[0][0] === 'number') {
        // 简单坐标数组 [[lng,lat], [lng,lat], ...]
        coords.forEach((coord) => callback(coord));
      } else if (Array.isArray(coords[0])) {
        // 嵌套坐标数组 [[[lng,lat], [lng,lat], ...], ...]
        coords.forEach((subCoords) =>
          this.processCoordinates(subCoords, callback),
        );
      }
    },
    // 初始化饼图
    initPieChart(company) {
      // 解析ratio数据
      let ratioData = [];
      try {
        if (company.ratio) {
          ratioData = JSON.parse(company.ratio);
        }
      } catch (e) {
        console.error('解析股份占比数据失败:', e);
        ratioData = [];
      }

      // 转换数据格式为ECharts所需格式
      const chartData = ratioData.map((item) => ({
        name: item.Shareholder,
        value: Number(item.ratio.replace('%', '')), // 去除百分号，只保留数字
      }));
      let otherValue = 0;
      chartData.forEach((item) => {
        otherValue += item.value;
      });
      if (otherValue < 100 && otherValue > 0) {
        chartData.push({
          name: '其他',
          value: 100 - otherValue,
        });
      }
      console.log(chartData, 'chartData');
      // 获取DOM容器并初始化图表
      const pieContainer = document.getElementById('SharesPie');
      if (this.pieChart) {
        this.pieChart.dispose(); // 销毁已有实例
      }
      this.pieChart = echarts.init(pieContainer);

      // 字符串截断工具函数：超过maxLength则截断并加省略号
      function truncateText(text, maxLength = 7) {
        if (typeof text !== 'string') return text;
        return text.length > maxLength
          ? text.slice(0, maxLength) + '...'
          : text;
      }

      // 饼图配置
      const option = {
        tooltip: {
          trigger: 'item',
          // tooltip显示完整文字（不截断）
          formatter: (params) =>
            `${params.seriesName}<br/>${params.name}: ${params.percent}%`,
        },
        legend: {
          orient: 'horizontal',
          show: false,
          bottom: 0,
          textStyle: {
            fontSize: 14,
          },
          padding: [10, 0, 0, 0],
          // 图例文字截断处理
          formatter: (name) => truncateText(name),
          // 禁用图例点击能力
          selectedMode: false, // 关键配置：设为false则无法点击切换系列显示状态
        },
        series: [
          {
            name: '占有比例',
            type: 'pie',
            center: ['50%', '50%'],
            radius: ['40%', '65%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: 'bold',
                // 鼠标 hover 时显示完整文字
                formatter: (params) => `${params.name}: ${params.percent}%`,
              },
            },
            // 饼图外侧标签文字截断处理
            label: {
              show: true,
              position: 'outside',
              formatter: (params) =>
                `${truncateText(params.name)}: ${params.percent}%`,
              fontSize: 14,
              color: '#ffffff',
              lineStyle: {
                color: '#999',
                width: 1,
              },
            },
            labelLine: {
              show: true,
              length: 15,
              length2: 20,
              smooth: false,
            },
            data: chartData,
          },
        ],
      };

      // 设置图表选项
      this.pieChart.setOption(option);

      // 监听窗口大小变化，调整图表尺寸
      window.addEventListener('resize', this.handleResize);
    },
    // 处理窗口大小变化
    handleResize() {
      if (this.pieChart) {
        this.pieChart.resize();
      }
    },
    getCompanys() {
      let params = {
        types: '',
      };
      switch (this.$store.state.chinaMap.dataType) {
        case 3:
          this.$set(params, 'types', '1,2,3');
          break;
        case 1:
          this.$set(params, 'types', '1,3');
          break;
        case 2:
          this.$set(params, 'types', '2,3');
          break;
      }
      getCompanyList(params).then((res) => {
        if (res.code === 200) {
          const AdcodeList = [];
          this.resData = res.data;
          // 获取公司分布的省份
          this.resData.forEach((item) => {
            AdcodeList.push({
              adcode: Number(item.region.toString().slice(0, 2) + '0000'),
              name: '',
            });
          });
          console.log(this.resData, 'this.resData');
          // 过滤重复的省份数据
          window.companyAdcodeList = Object.values(
            AdcodeList.reduce((acc, item) => {
              // 以adcode为键，若不存在则存入，已存在则跳过
              if (!acc[item.adcode]) {
                acc[item.adcode] = item;
              }
              return acc;
            }, {}), // 初始值为空对象
          );
          // 为当前adcode所在的省份匹配名称
          window.companyAdcodeList.forEach((item) => {
            provinceCenters.forEach((temp) => {
              if (item.adcode == temp.adcode) {
                item.name = temp.name;
                item.coords = temp.coords;
              }
            });
          });
          // 以四川省为起点，向全国合作公司所在公司省份辐射
          this.setMapLinesData(window.companyAdcodeList);
          this.formatChart(
            this.historyData[this.historyData.length - 1].geoJson,
            '中国',
          );
        } else {
          this.mapPointArr = [];
        }
      });
    },
    setMapLinesData(companyAdcodeList) {
      // 四川省中心点（成都）：104.0665° E, 30.6799° N
      const sichuanCenter = [104.0665, 30.6799];
      // 构造辐射路径数据
      const arrowInterval = 400;
      // 过滤数据，避免渲染报错
      let result = companyAdcodeList.filter((item) => {
        return item.name !== '四川省' && item.name !== '';
      });
      const linesData = result.map((item, index) => ({
        name: `四川→${item.name}`,
        coords: [sichuanCenter, item.coords],
        // 第index个路径，延迟 index * arrowInterval 毫秒出发
        animationDelay: index * arrowInterval,
        // 动画更新时保持相同延迟，确保循环时间隔不变
        animationDelayUpdate: index * arrowInterval,
      }));

      this.optionMap.series.forEach((item) => {
        if (item.type === 'lines') {
          item.data = linesData;
        }
      });
    },
    clearMapLinesData() {
      this.optionMap.series.forEach((item) => {
        if (item.type === 'lines') {
          item.data = [];
        }
      });
    },
    getMapLevel2Icon() {
      return new Promise((resolve, reject) => {
        // 清理上层地图撒点缓存数据
        this.resData = [];
        window.companyAdcodeList = undefined;
        this.clearMapLinesData();
        let params = {
          region: this.$store.state.chinaMap.currentlyMapAdcode,
          types: this.$store.state.chinaMap.dataType == 1 ? '1,3' : '2,3',
          companyId: this.$store.state.chinaMap.companyId,
        };

        let serseObj = {
          type: 'scatter',
          coordinateSystem: 'geo',
          zlevel: 2,
          rippleEffect: {
            period: 4,
            brushType: 'stroke',
            scale: 4,
          },
          label: {
            show: true,
            color: '#fff',
          },
          symbol: 'pin', // 定位图标样式
          symbolSize: 50,
          symbolOffset: [0, -5],
          data: [],
        };

        getMapDataLevel2(params)
          .then((res) => {
            if (res.code === 200) {
              let data = [];
              let tempDataList = res.data;

              // 包含所有城市中心点数据的数组
              centroidList.forEach((item) => {
                // 当前需要被展示在地图上的数据
                tempDataList.forEach((temp) => {
                  if (item.adcode == temp.cityCode && temp.count !== 0) {
                    data.push({
                      itemStyle: { color: '#0b4631' },
                      label: {
                        formatter: (parmars) => {
                          return parmars.data.count;
                        },
                      },
                      adcode: temp.cityCode,
                      count: temp.count,
                      name: item.name,
                      value: item.centroid,
                    });
                  }
                });
              });

              this.$set(serseObj, 'data', data);
              myChartMap.setOption({
                series: [serseObj],
              });

              resolve(); // 数据处理完成，resolve Promise
            } else {
              this.$set(serseObj, 'data', []);
              myChartMap.setOption({
                series: [serseObj],
              });

              resolve(); // 即使失败也 resolve，避免阻塞流程
            }
          })
          .catch((error) => {
            console.error('获取二级地图撒点数据失败:', error);
            reject(error); // 出错时 reject Promise
          });
      });
    },
    getMapLevel3Icon() {
      return new Promise((resolve, reject) => {
        window.companyAdcodeList = undefined;
        let params = {
          region: this.$store.state.chinaMap.currentlyMapAdcode,
          types: this.$store.state.chinaMap.dataType == 1 ? '1,3' : '2,3',
          companyId: this.$store.state.chinaMap.companyId,
        };
        this.clearMapLinesData();
        getMapDataLevel3(params)
          .then((res) => {
            if (res.code === 200) {
              this.resData = [...res.data];
              resolve(); // 数据处理完成，resolve Promise
            } else {
              this.mapPointArr = [];
              resolve(); // 即使失败也 resolve，避免阻塞流程
            }
          })
          .catch((error) => {
            console.error('获取三级地图撒点数据失败:', error);
            reject(error); // 出错时 reject Promise
          });
      });
    },
  },
  destroyed() {
    if (myChartMap) myChartMap.clear();
    if (charTimer) {
      clearInterval(charTimer);
      charTimer = null;
    }
  },
};
</script>
<style scoped lang="less">
.about {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.infoCards {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 10%;
  margin: auto;
  z-index: 999;
}
#myMap {
  width: 100%;
  height: 100%;
  margin: 0 auto; /* 水平居中 */
}
.btn {
  position: absolute;
  top: 0px;
  right: 10px;
  font-size: 30px;
  background: linear-gradient(
    180deg,
    rgba(0, 255, 153, 0) 0%,
    rgba(23, 153, 110, 1) 100%
  );
  border: 2px solid;
  box-shadow:
    /* 内发光增强边框层次感 */
    inset 0 0 2px rgba(100, 255, 255, 0.6),
    /* 外阴影弱化边框硬边 */ 0 1px 1px rgba(0, 100, 100, 0.3);
  border-image: linear-gradient(
    135deg,
    rgba(71, 212, 157, 1) 0%,
    rgba(1, 138, 90, 0) 47.25%,
    rgba(71, 212, 157, 1) 100%
  );
}
.Tooltip {
  position: absolute;
  bottom: 0px;
  right: 0px;
}
.map-point {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100px;
  height: 100px;
  background-size: 100%;
  display: none;
}
/* 新增企业列表样式 */
.company-list-icon {
  position: absolute;
  padding: 7px 0;
  top: 60px;
  right: 10px;
  width: 122px;
  height: 45px;
  border-radius: 3px;
  background: linear-gradient(
    180deg,
    rgba(0, 255, 153, 0) 0%,
    rgba(23, 153, 110, 1) 100%
  );
  border: 2px solid;
  box-shadow:
    /* 内发光增强边框层次感 */
    inset 0 0 2px rgba(100, 255, 255, 0.6),
    /* 外阴影弱化边框硬边 */ 0 1px 1px rgba(0, 100, 100, 0.3);
  border-image: linear-gradient(
    135deg,
    rgba(71, 212, 157, 1) 0%,
    rgba(1, 138, 90, 0) 47.25%,
    rgba(71, 212, 157, 1) 100%
  );
  cursor: pointer;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    color: #ffffff;
    font-size: 26px;
    font-weight: 600;
  }
}

.company-list-container {
  position: absolute;
  top: 58px;
  right: 10px;
  width: 250px;
  max-height: 300px;
  background: linear-gradient(
    180deg,
    rgba(0, 255, 153, 0) 0%,
    rgba(23, 153, 110, 1) 100%
  );
  border: 2px solid;
  box-shadow:
    /* 内发光增强边框层次感 */
    inset 0 0 2px rgba(100, 255, 255, 0.6),
    /* 外阴影弱化边框硬边 */ 0 1px 1px rgba(0, 100, 100, 0.3);
  border-image: linear-gradient(
    135deg,
    rgba(71, 212, 157, 1) 0%,
    rgba(1, 138, 90, 0) 47.25%,
    rgba(71, 212, 157, 1) 100%
  );
  backdrop-filter: blur(4px);
  border-radius: 5px;
  z-index: 1000;
  overflow: hidden;

  .company-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background: rgba(0, 167, 255, 0.1);

    span {
      font-size: 18px;
      color: #fff;
    }

    img {
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }

  .company-list-content {
    overflow-y: auto;
    max-height: 250px;
    padding: 5px;

    .company-item {
      padding: 8px 10px;
      margin: 5px 0;
      color: #fff;
      background: rgba(0, 167, 255, 0.1);
      border-radius: 3px;
      cursor: pointer;
      transition: all 0.3s;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 16px;
      white-space: nowrap;
      &:hover {
        background: rgba(0, 167, 255, 0.3);
        transform: translateX(5px);
      }
    }
    .choseColor {
      background: rgba(0, 167, 255, 0.3);
      transform: translateX(5px);
    }
  }
}
</style>
